import { React, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {getFormattedDate,isEndDateGreater,changeDateFormat} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import axios from 'axios';
import { API_URL } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import  {getMajorWPIReport}  from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';

function MajorWPIReport() {
    const token = useContext(MyContextProvider).token;
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const storedLanguage = localStorage.getItem('language');
    const today = new Date();
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const monthMap = {
        'Jan': 'जनवरी',
        'Feb': 'फरवरी',
        'Mar': 'मार्च',
        'Apr': 'अप्रैल',
        'May': 'मई',
        'Jun': 'जून',
        'Jul': 'जुलाई',
        'Aug': 'अगस्त',
        'Sep': 'सितंबर',
        'Oct': 'अक्टूबर',
        'Nov': 'नवंबर',
        'Dec': 'दिसंबर'
      };
     
      
const convertDate=(dateStr)=>{
    const [month, year] = dateStr.split('-');
    const hindiMonth = monthMap[month] || month;
    return `${hindiMonth}-${year}`;
 }

    
  //handle excel sheet ***************
const handleGenerateExcel = async() => {

    if (!startDate || !endDate) {
        toast.error('Please select the date range', messages.COLOR_RED);
        return;
      }
      
    if(!isEndDateGreater(startDate,endDate)){
        toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
        return;
      }

      let sDate= getFormattedDate(startDate);
      let eDate=  getFormattedDate(endDate);

  try {
  showLoading(true);

      let post_data={
          fromDate: sDate,
          toDate:eDate
      }
 
      const response = await axios.post(`${API_URL}api/price/MajorWPIReport`, post_data, config);
      const reportData = response.data;

      if(reportData.status){
          let allData= reportData.data.result
         downloadReport(allData,sDate,eDate)

      }else{
        toast.error('Data is not found', messages.COLOR_RED);
      return;
      }

  } catch (error) {
  console.error(error);

  }finally{
  showLoading(false);
  }
 }


 
 const downloadReport=(allData,sDate,eDate)=>{

  const transformedData = allData.map((item ,index)=>{

     return [
     `${item.Period} (${convertDate(item.Period)})`,
     item['All Groups'],
     item['PRIMARY ARTICLES'],
     item['FUEL, POWER, LIGHT & LUBRICANTS'],
     item['MANUFACTURED PRODUCTS']
    ]

  })


  let excelObjectData = {
       fileName:`Major_WPI`,
       fileType:'xls',
       sheetName: 'major_wpi11',
       firstRowMergeCells: 'A1:E1',
       firstRowExportDate:  changeDateFormat(new Date()),
       secondRowMergeCells: 'A2:E2',
       secondRowText: `सारीणी-1 (ख) उत्तर प्रदेश के मासिक थोक भाव सूचकांक -प्रमुख  वर्गवार (आधार वर्ष  2011-12=100)`,
       thirdRowMergeCells: 'A3:E3',
       thirdRowText: `Table-1(b) Major Group-wise Monthly Wholesale Price Index Numbers Of U.P. (Base year 2011-12=100)`,
       headerHindiColumns:['अवधि','समस्त वर्ग','प्रमुख वर्ग प्राथमिक वस्तुए','ईंधन ,शक्ति आदि','विनिर्मित उत्पाद '],
       headerEnglishColumns:['Period','All Groups','PRIMARY ARTICLES','FUEL, POWER, LIGHT & LUBRICANTS','MANUFACTURED PRODUCTS'],
       excelRowData:transformedData,
     };

     excelObjectData.excelRowData = transformedData;
      getMajorWPIReport(excelObjectData);
   }
 
   return (
     <>
         <ToastContainer />
         <GlobalLoading />
         <div className="container-fluid py-3">
             <div className="card mx-3 mb-3">
                 <div className="card-body pb-1">
                     <div className="row align-items-center">
                         <h4 className="page_heading">
                             <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.MAJOR_WPI_REPORT : priceTitle.en.MAJOR_WPI_REPORT }} />
                         </h4>
                         <div className="row align-items-center">
                         
                         
                         <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                  <label className="fw-bold h6">From Date</label>
                                  <DatePicker
                                      className="form-control calendar_icon"
                                      selected={startDate}
                                      onChange={(e) => { setStartDate(e) }}
                                      dateFormat="MMM yyyy"
                                      showMonthYearPicker
                                      placeholderText="Select month"
                                      maxDate={today}
                                  />
                              </div>
 
 
                         <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                  <label className="fw-bold h6">To Date</label>
                                  <DatePicker
                                      className="form-control calendar_icon"
                                      selected={endDate}
                                      onChange={(e) => { setEndDate(e) }}
                                      dateFormat="MMM yyyy"
                                      showMonthYearPicker
                                      placeholderText="Select month"
                                      maxDate={today}
                                  />
                              </div>
 
 
                         <div className="col-xl-2 col-lg-4 mb-3">
                             <label className="w-100 d-none d-sm-block">&nbsp;</label>
                             <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                         </div>
                         </div>
 
 
                     </div>
                 </div>
             </div>
         </div>
    </>
   )
}

export default MajorWPIReport